module.exports = __webpack_public_path__ + "img/scroll_top.d6d0422c.png";